export default function transform(value, style) {
    if (style) {
        style.transform = value;
        style.webkitTransform = value;
        return;
    }
    return ['-webkit-', '-ms-', ''].map(prefix => `${prefix}transform:${value}`).join(';');
}
